module.exports = __webpack_public_path__ + "svg/icons/icon-arrow-up.svg";